// Renders the author's text exactly as supplied: every character, space and line break. No markdown, no restructuring.
export default function PlainBody({ text }) {
  return (
    <div className="paper-prose paper-lead" data-testid="paper-body">
      <div className="whitespace-pre-wrap break-words text-[17px] sm:text-lg leading-[1.85] text-slate-300/90" data-testid="plain-body-text">{text}</div>
    </div>
  );
}
